import {
    Box,
    Button,
    Flex,
    Image,
    Spacer,
    Heading,
    Text,
    Badge,
    Tooltip,
} from '@chakra-ui/react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { FaEye, FaEdit } from "react-icons/fa";
import { MdChangeCircle, MdDeleteForever } from "react-icons/md";

import { useState } from 'react'

const AdminIndustryCard = ({ industryName, data, onDelete }) => {

    return (
        <Box borderWidth={'1px'} borderColor={'gray.300'} p={2}>
            <Flex
                align="center"
                flexDirection={['column', 'column', 'row', 'row']}
                p={['3', '3', '0', '0']}
            >
                <Box mb={['2', '2', '0', '0']}>
                    <Flex
                        align="center"
                        flexDirection={['column', 'column', 'row', 'row']}
                        justify={['center', 'center', 'start', 'start']}
                        textAlign={['center', 'center', 'start', 'start']}
                    >
                        <Image
                            src={data?.image}
                            alt=""
                            boxSize={'80px'}
                            objectFit={'contain'}
                            mr={['0', '0', '4', '4']}
                            mb={['2', '2', '0', '0']}
                        />
                        <Box>
                            <Heading as="h3" fontSize="xl">
                                {industryName}                                
                            </Heading>

                            <Text>Created on: {data?.created_at}</Text>
                        </Box>
                    </Flex>
                </Box>
                <Spacer />
                                
                {/* <Box>
                    <Tooltip label="View details" hasArrow>
                        <Button
                        as={Link}
                        to={`/admin/industry-list/details/${data?.id}`}
                        size="sm"
                        bg="orange.400" // Orange for "View"
                        color="white"
                        _hover={{ bg: "orange.500" }}
                        variant="solid"
                        ml={["0", "0", "2", "0"]}
                        >
                        <FaEye />
                        </Button>
                    </Tooltip>
                </Box> */}

                <Box>
                    <Tooltip label="Edit details" hasArrow>
                        <Button
                        as={Link}
                        to={`/admin/industry/edit/${data?.id}`}
                        size="sm"
                        bg="orange.400" 
                        color="white"
                        _hover={{ bg: "orange.500" }}
                        variant="solid"
                        ml={["0", "0", "2", "0"]}
                        >
                        <FaEdit />
                        </Button>
                    </Tooltip>
                </Box>

                <Box>
                <Tooltip label="Delete" hasArrow>
                    <Button
                    onClick={() => onDelete(data.id)}
                    size="sm"
                    bg="red.500" // Red for "Delete"
                    color="white"
                    _hover={{ bg: "red.600" }}
                    variant="solid"
                    ml={["1", "0", "2", "1"]}
                    >
                    <MdDeleteForever />
                    </Button>
                </Tooltip>
                </Box>
            </Flex>
        </Box>
    )
}

export default AdminIndustryCard
